export default {
  props: {
    keyword: {
      type: String,
      default: '',
    },
    idPrefix: {
      type: String,
      default: 'store-selector',
    },
  },

  emits: ['submit', 'emptySearch'],

  data() {
    return {
      localKeyword: '',
    };
  },

  watch: {
    keyword: {
      handler(value) {
        this.localKeyword = value;
      },
      immediate: true,
    },

    localKeyword: {
      handler(value) {
        value = value ? value : '';
        if (value.length === 0) {
          this.$emit('emptySearch');
        }
      },
    },
  },

  methods: {
    submit() {
      this.$emit('submit', this.localKeyword);
    },
  },
};
